/**
 * @module MonarchFallback
 * @description Min-height fallback for Monarch
 */

import styles from "./index.module.css";

export const Component = ({ height = [] }) => (
  <div
    style={{
      "--mobile": height[0],
      "--tablet": height[1],
      "--desktop": height[2],
    }}
    className={styles.fallback}
  />
);

export default Component;
